export { default } from './part-why-choose-us';
